

<template>
  <AppLayout>
    <div class="inventory">
      <section id="suppliers-add" class="filter-search">
        <div class="container">
          <div class="d-flex align-items-center gap-2 mb-3 flex-wrap">
            <div v-if="lowestBidAwardsMode" class="alert alert-info py-1 px-2 mb-0 small" style="font-size:11px;">
              <i class="fas fa-info-circle me-1"></i>
              Pre-filled with lowest bid items for this supplier.
              <span v-if="lowestBidAwardCount > 1">Create additional POs for {{ lowestBidAwardCount - 1 }} other supplier(s) from the tender submissions page.</span>
            </div>
          </div>
          <p class="fw-bold">1. Add Details</p>
          <div>
            <div class="form">
              <div class="row">
                <div class="col-md-2">
                  <div class="form-group">
                    <label for="product-name">Department</label>
                    <select v-model="department" class="full" v-if="departments?.length > 0">
                      <option :value="null">-- Select department --</option>
                      <option v-for="dept in departments" v-bind:key="dept.id" :value="dept.id">
                          {{ dept.name }}
                      </option>
                    </select>
                  </div>
                </div>
                <div class="col-md-3" v-if="department && purchaseVerifiers?.length > 0">
                  <div class="form-group">
                    <label>HOD Approver</label>
                    <div class="verifier-badge-list">
                      <span v-for="v in purchaseVerifiers" :key="v.id" class="badge bg-primary me-1 mb-1">{{ v.name }}</span>
                    </div>
                  </div>
                </div>
                <div class="col-md-3" v-else-if="department && verifiersLoading">
                  <div class="form-group">
                    <label>HOD Approver</label>
                    <div class="text-muted small"><span class="spinner-border spinner-border-sm" role="status"></span> Loading...</div>
                  </div>
                </div>
                <div class="col-md-3" v-else-if="department && !verifiersLoading && purchaseVerifiers?.length === 0">
                  <div class="form-group">
                    <label>Purchase Verifier</label>
                    <div class="text-muted small">No verifier assigned for this department</div>
                  </div>
                </div>
                <div class="col-md-3" v-if="department && purchaseStampers?.length > 0">
                  <div class="form-group">
                    <label>Finance Approver(s)</label>
                    <div class="verifier-badge-list">
                      <span v-for="s in purchaseStampers" :key="s.id" class="badge bg-secondary me-1 mb-1">{{ s.name }}</span>
                    </div>
                  </div>
                </div>
                <div class="col-md-3" v-else-if="department && stampersLoading">
                  <div class="form-group">
                    <label>Finance Approver(s)</label>
                    <div class="text-muted small"><span class="spinner-border spinner-border-sm" role="status"></span> Loading...</div>
                  </div>
                </div>
                <div class="col-md-3" v-else-if="department && !stampersLoading && purchaseStampers?.length === 0">
                  <div class="form-group">
                    <label>Finance Approver(s)</label>
                    <div class="text-muted small">No stamper assigned for this department</div>
                  </div>
                </div>
                <div class="col-md-3" v-if="department && taxableBase >= CEO_NET_AMOUNT_THRESHOLD && purchaseCeoStampers?.length > 0">
                  <div class="form-group">
                    <label>CEO/COO Approver(s)</label>
                    <div class="verifier-badge-list">
                      <span v-for="c in purchaseCeoStampers" :key="c.id" class="badge bg-warning text-dark me-1 mb-1">{{ c.name }}</span>
                    </div>
                  </div>
                </div>
                <div class="col-md-3" v-else-if="department && taxableBase >= CEO_NET_AMOUNT_THRESHOLD && ceoStampersLoading">
                  <div class="form-group">
                    <label>CEO/C00 Approver(s)</label>
                    <div class="text-muted small"><span class="spinner-border spinner-border-sm" role="status"></span> Loading...</div>
                  </div>
                </div>
                <div class="col-md-3" v-else-if="department && taxableBase >= CEO_NET_AMOUNT_THRESHOLD && !ceoStampersLoading && purchaseCeoStampers?.length === 0">
                  <div class="form-group">
                    <label>CEO/COO Approver(s)</label>
                    <div class="text-muted small">No CEO stamper assigned for this department</div>
                  </div>
                </div>
                <div class="col-md-2">
                  <div class="form-group">
                    <label for="item-code">Project</label>
                    <!--<input type="text" class="form-control" id="item-code" v-model="project">-->
                    <select v-model="project" class="full" id="projects"  v-if="projects?.length > 0">
                      <option v-for="proj in projects" v-bind:Key="proj.id" :value="proj.name">
                          {{ proj.name }}
                      </option>
                    </select>
                  </div>
                </div>
                  <div class="col-md-3">
                    <div class="form-group">
                      <label for="tender">Tender (optional)</label>
                      <select v-if="!tendersLoading && tenders?.length > 0" v-model="tenderId" @change="onTenderChange" class="full" id="tender">
                        <option value="">-- None --</option>
                        <option v-for="t in tenders" :key="t.id" :value="t.id">{{ t.title }} {{ t.referenceNumber ? '(' + t.referenceNumber + ')' : '' }}</option>
                      </select>
                      <div v-else-if="tendersLoading" class="text-muted small mt-1">
                        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span> Loading tenders...
                      </div>
                      <div v-else class="text-muted small mt-1">No tenders available</div>
                    </div>
                  </div>
                              <div class="col-md-3" v-if="tenderSubmissions && tenderSubmissions.length > 0">
                                <div class="form-group">
                                  <label for="award">Awarded Submission (optional)</label>
                                  <select v-model="tenderSubmissionId" class="full" id="award" v-if="tenderSubmissions && tenderSubmissions.length > 0" :disabled="tenderSubmissionDisabled">
                                    <option :value="null">-- None --</option>
                                    <option v-for="s in tenderSubmissions" :key="s.id" :value="s.id">{{ s.companyName }} {{ s.proposedValue ? '(' + s.proposedValue + ')' : '' }} {{ s.tenderContract ? '- Contract' : '- Normal' }}</option>
                                  </select>
                                </div>
                              </div>
                              <div class="col-md-3">
                                <div class="form-group">
                                  <label for="suppliers">Supplier</label>
                                  <select v-if="!supplierInputDisabled && suppliers.length > 0" v-model="supplierId" class="full" id="suppliers">
                                      <option v-for="supplier in suppliers" v-bind:Key="supplier.id" :value="supplier.id">
                                          {{ supplier.name }}
                                      </option>
                                  </select>
                                  <input v-else type="text" class="form-control" :value="selectedSupplierName" readonly />
                                </div>
                              </div>
                <div class="col-md-3">
                  <div class="form-group">
                    <label for="supplierContact">Contacts</label>
                    <input type="text" class="form-control" id="supplierContact" readonly v-model="supplierContact">
                  </div>
                </div>
                <!--<div class="col-md-2">
                  <div class="form-group">
                    <label for="payments">Terms of Payment</label>
                    <select v-model="paymentId" class="full" id="payments"  v-if="payments.length > 0">
                        <option v-for="payment in payments" v-bind:Key="payment.id" :value="payment.id">
                            {{ payment.payment }}
                        </option>
                    </select>
                  </div>
                </div>-->

                <div class="col-md-2">
                  <div class="form-group">
                    <label for="item-code">Requisition Number</label>
                    <input type="text" class="form-control" id="item-code" v-model="requisitionNumber" readonly />
                  </div>
                </div>

                <div class="col-md-1">
                  <div class="form-group">
                    <label for="item-code">VAT {{vat}}</label>
                    <div class="components-button">
                      <span class="switcher switcher-1">
                        <input type="checkbox" id="switcher-1" v-model="vat">
                        <label for="switcher-1"></label>
                      </span>
                    </div>
                  </div>
                </div>
              
                <div class="col-md-2">
                  <div class="form-group">
                    <label for="discount">Discount (%) <span class="text-muted small">(optional)</span></label>
                    <input type="number" step="0.01" min="0" max="100" class="form-control" v-model.number="discount" />
                  </div>
                </div>

                <div class="col-md-2">
                  <div class="form-group">
                    <label for="deliveryDate">Delivery Date</label>
                    <input type="date" class="form-control" id="deliveryDate" v-model="deliveryDate" />
                  </div>
                </div>

                <div class="col-md-2">
                  <div class="form-group">
                    <label for="creditPeriod">Credit Period (days) <span class="text-muted small">(optional)</span></label>
                    <input type="number" min="0" class="form-control" id="creditPeriod" v-model.number="creditPeriod" placeholder="e.g. 30" />
                    <small v-if="paymentDueDate" class="text-info">Due: {{ paymentDueDate }}</small>
                  </div>
                </div>

                <div class="col-md-2" v-if="purchaseId && isCredit && canBeFulfilled">
                  <div class="form-group">
                    <label>Payment Status</label>
                    <div class="d-flex align-items-center gap-2 mt-1">
                      <div class="components-button">
                        <span class="switcher switcher-1">
                          <input type="checkbox" id="isPaid-toggle" :checked="isPaid" @change="toggleIsPaid" :disabled="togglingPayment">
                          <label for="isPaid-toggle"></label>
                        </span>
                      </div>
                      <span v-if="togglingPayment" class="spinner-border spinner-border-sm text-primary" role="status"></span>
                      <span v-else :class="isPaid ? 'text-success fw-bold' : 'text-danger fw-bold'" style="font-size:12px;">
                        {{ isPaid ? 'Paid' : 'Unpaid' }}
                      </span>
                    </div>
                  </div>
                </div>

                <div class="col-md-12 mt-3">
                  <div class="form-group">
                    <label for="termsAndConditions">Terms and Conditions</label>
                    <textarea id="termsAndConditions" class="form-control" rows="3" v-model="termsAndConditions" placeholder="Enter terms and conditions..."></textarea>
                  </div>
                </div>

              
                <div class="col-md-1" v-if="!tenderId" :style="{ 'display': displayButton }">
                    <button class="btn btn-style-2" style="margin-top: 31px;" @click="postPurchase" :disabled="creatingPurchase">
                      <span v-if="creatingPurchase">
                        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                        &nbsp;Creating...
                      </span>
                      <span v-else>Add</span>
                    </button>
                </div>

                
              </div>
  
            </div>
          </div> <!-- v-if="tenderId || purchaseId"  -->
          <div  style="margin-top:30px"  v-if="tenderId || purchaseId">
            <p class="fw-bold">2. Add Products</p>
            <div v-if="itemsLoading" class="text-center my-4">
              <div class="spinner-border text-primary" role="status">
                <span class="sr-only">Loading...</span>
              </div>
              <p class="mt-2 text-muted">Loading items...</p>
            </div>
            <div v-else>
            <table class="table table-hover">
                <thead>
                    <th style="background-color: #f8f9fa; font-size: 11px; font-weight: 600; padding: 15px 8px; text-align: left;">No.</th>
                    <th style="background-color: #f8f9fa; font-size: 11px; font-weight: 600; padding: 15px 8px; text-align: left;">Product</th>
                    <th style="background-color: #f8f9fa; font-size: 11px; font-weight: 600; padding: 15px 8px; text-align: left;">Product Code</th>
                    <th style="background-color: #f8f9fa; font-size: 11px; font-weight: 600; padding: 15px 8px; text-align: left;">Product Description</th>
                    <th style="background-color: #f8f9fa; font-size: 11px; font-weight: 600; padding: 15px 8px; text-align: left;">Unit</th>
                    <th style="background-color: #f8f9fa; font-size: 11px; font-weight: 600; padding: 15px 8px; text-align: left;">Qty In Tender</th>
                    <th style="background-color: #f8f9fa; font-size: 11px; font-weight: 600; padding: 15px 8px; text-align: left;">Qty Available</th>
                    <th style="background-color: #f8f9fa; font-size: 11px; font-weight: 600; padding: 15px 8px; text-align: left;">Qty Requesting</th>
                    <th style="background-color: #f8f9fa; font-size: 11px; font-weight: 600; padding: 15px 8px; text-align: left;">Price</th>
                    <th style="background-color: #f8f9fa; font-size: 11px; font-weight: 600; padding: 15px 8px; text-align: left;">Action</th>
                </thead>
                <tbody v-if="items.length > 0">
                    <tr v-for="(item, index) in items" v-bind:key="item.id">

                        <td>{{ (index+1) }}</td>
                        <td>{{ item.Product?.name ?? item.name ?? '-' }}</td>
                        <td>{{ item.Product?.code ?? item.code ?? '-' }}</td>
                        <td>{{ item.description ?? '-' }}</td>
                            <td>{{ item.Product?.unit?.unit ?? item.unit?.unit ?? '-' }}</td>
                            <td>{{ item.tenderedQuantity ?? '-' }}</td>
                            <td>{{ isContractAward ? '-' : (item.availableQuantity !== null && item.availableQuantity !== undefined ? item.availableQuantity : '-') }}</td>
                            <td>
                              <input
                                type="number"
                                min="0"
                                step="1"
                                class="form-control"
                                v-model.number="item.quantity"
                                :max="(item.availableQuantity !== null && item.availableQuantity !== undefined) ? item.availableQuantity : undefined"
                              />
                            </td>
                        <td>
                          <input type="number" step="0.01" min="0" class="form-control" v-model.number="item.price" />
                        </td>
                        <td>
                            <button class="btn btn-default btn-sm" style="border:1px solid black;" @click="deleteProduct(item.id)">Remove</button>
                        </td>
                    </tr>
                    <tr>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td>Total ({{ currency }})</td>
                      <td>{{ formatMoney(total, currency) }}</td>
                      <td></td>
                    </tr>
                    <tr v-if="discount > 0">
                      <td colspan="7"></td>
                      <td>Discount ({{ discount }}%)</td>
                      <td>-{{ formatMoney(discountAmount, currency) }}</td>
                      <td></td>
                    </tr>
                    <tr v-if="vat">
                      <td colspan="7"></td>
                      <td>VAT (16%)</td>
                      <td>{{ formatMoney(vatAmount, currency) }}</td>
                      <td></td>
                    </tr>
                    <tr style="font-size:11px;">
                      <td colspan="7"></td>
                      <td>Net Total ({{ currency }})</td>
                      <td>{{ formatMoney(netTotal, currency) }}</td>
                      <td></td>
                    </tr>
                </tbody>
                <tfoot v-if="items.length > 0">
                  <tr>
                    <td colspan="10" class="pt-2 pb-1" style="border-top:none; font-size:11px;">
                      <!--<span class="text-muted me-3"><i class="fas fa-stamp me-1"></i> Stamp required</span>-->
                      <span v-if="taxableBase >= CEO_NET_AMOUNT_THRESHOLD" class="text-muted"><i class="fas fa-user-tie me-1"></i> CEO Signature required (net excl. VAT &ge; {{ CEO_NET_AMOUNT_THRESHOLD.toLocaleString() }})</span>
                    </td>
                  </tr>
                </tfoot>
                <div v-else>
                  <label for="" class="text-danger" style="margin: 0px;  display: block;">No product found</label>
                </div>
            </table>
            </div>
            
            <div class="mb-5">
              <button class="btn-style small" style="border: 1px solid black; float: right; margin-bottom: 100px;" @click="generatePurchase" :disabled="generatingPurchase">
                <span v-if="generatingPurchase">
                  <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                  &nbsp;Generating...
                </span>
                <span v-else>Generate</span>
              </button>
              <!--<button class="btn btn-default" style="border: 1px solid black; float: right; margin-right: 10px;" @click="$router.push('/purchases')">Close</button>-->
            </div>
          </div>
        
        <!-- New Product Modal -->
        <Modal v-if="showNewProductModal" @close="closeNewProductModal">
          <template #header>
            Create Product
          </template>
          <template #body>
            <div class="form-group">
              <label>Name</label>
              <input class="form-control" v-model="newProduct.name" />
            </div>
            <div class="form-group">
              <label>Code</label>
              <input class="form-control" v-model="newProduct.code" />
            </div>
            <div class="form-group">
              <label>Unit</label>
              <select class="form-control" v-model.number="newProduct.unitId">
                <option :value="null">-- Select unit --</option>
                <option v-for="u in units" :key="u.id" :value="u.id">{{ u.unit }}</option>
              </select>
            </div>
            <div class="form-group">
              <label>Sub Unit</label>
              <select class="form-control" v-model.number="newProduct.subunitId">
                <option :value="null">-- Select sub unit --</option>
                <option v-for="su in filteredSubUnits" :key="su.id" :value="su.id">{{ su.subUnit || su.name || su.unit }}</option>
              </select>
            </div>
            <div class="form-group">
              <label>Category</label>
              <select class="form-control" v-model.number="newProduct.categoryId">
                <option :value="null">-- Select category --</option>
                <option v-for="c in categories" :key="c.id" :value="c.id">{{ c.category }}</option>
              </select>
            </div>
            <div class="form-group">
              <label>Subcategory</label>
              <select class="form-control" v-model.number="newProduct.subcategoryId">
                <option :value="null">-- Select subcategory --</option>
                <option v-for="sc in filteredSubcategories" :key="sc.id" :value="sc.id">{{ getSubcategoryLabel(sc) }}</option>
              </select>
            </div>
            <div class="form-group">
              <label>Purchase Price</label>
              <input type="number" class="form-control" v-model.number="newProduct.pricePurchase" />
            </div>
              <div class="form-group">
                <label>Selling Price</label>
                <input type="number" class="form-control" v-model.number="newProduct.sellingPrice" />
              </div>
              <div class="form-group">
                <label>Brand</label>
                <input class="form-control" v-model="newProduct.brand" />
              </div>
              <div class="form-group">
                <label>Barcode</label>
                <input class="form-control" v-model="newProduct.barcode" />
              </div>
              <div class="form-group">
                <label>Reorder Level</label>
                <input type="number" class="form-control" v-model.number="newProduct.reorderLevel" />
              </div>
              <div class="form-group">
                <label>Tax Rate (%)</label>
                <input type="number" step="0.01" class="form-control" v-model.number="newProduct.taxRate" />
              </div>
            <div class="form-group">
              <label>Description</label>
              <input class="form-control" v-model="newProduct.description" />
            </div>
          </template>
          <template #footer>
            <div style="display:flex; gap:8px; justify-content:flex-end; width:100%">
              <button class="btn btn-secondary" @click="closeNewProductModal" :disabled="creatingProduct">Cancel</button>
              <button class="btn btn-primary" @click="createNewProduct" :disabled="creatingProduct">
                <span v-if="creatingProduct" class="spinner-border spinner-border-sm" role="status" aria-hidden="true" style="margin-right:8px"></span>
                <span v-if="creatingProduct">Creating…</span>
                <span v-else>Create & Add</span>
              </button>
            </div>
          </template>
        </Modal>
        </div>
      </section>
    </div>
  </AppLayout>
</template>
  
  <script>
  
  import { mapGetters, mapActions } from 'vuex'
  import Swal from 'sweetalert2'
  import AppLayout from '../../components/AppLayout.vue';
  import Modal from '../../components/Modal.vue'
  import axios from 'axios'
  import { tenderApi } from '@/api/tender'
  import { CEO_NET_AMOUNT_THRESHOLD } from '@/constants/purchaseCeoThreshold.js'

  export default {
    name: 'AddPurchasePage',
    components: {
      AppLayout,
      Modal,
    },
    data () {
      return {
        CEO_NET_AMOUNT_THRESHOLD,
        token: JSON.parse(localStorage.getItem('access_token')),
        displayItems: "none",
        displayButton: "block",
        supplierId: "",
        tenderId: null,
        paymentId: "",
        discount: 0,
        deliveryDate: '',
        creditPeriod: '',
        total: 0,
        supplierContact: "",
        productId: "",
        showNewProductModal: false,
        newProduct: {
          name: '',
          code: '',
          unitId: null,
          subunitId: null,
          categoryId: null,
          subcategoryId: null,
          pricePurchase: 0,
          sellingPrice: 0,
          brand: '',
          barcode: '',
          reorderLevel: 0,
          taxRate: 0,
          description: ''
        },
        tenders: [],
        tendersLoading: false,
        productCode: "",
        productDescription: "",
        productUnit: "",
        productQty: "",
        productRequest: "",
        productPrice: "",
        requisitionNumber: '',
        items: [],
        vat: true,
        purchaseId: null,
        isCredit: false,
        isPaid: false,
        canBeFulfilled: false,
        togglingPayment: false,
        department: null,
        termsAndConditions: '',
        itemsLoading: false,
        project: '',
        tenderSubmissions: [],
        tenderSubmissionId: null,
        tenderSubmissionDisabled: false,
        lowestBidAwardsMode: false,
        lowestBidAwardCount: 0,
        creatingPurchase: false,
        creatingProduct: false,
        generatingPurchase: false,
        purchaseVerifiers: [],
        purchaseStampers: [],
        purchaseCeoStampers: [],
        verifiersLoading: false,
        stampersLoading: false,
        ceoStampersLoading: false,
      }
    },
   
    computed: {
      ... mapGetters(["getPayments", "getSuppliers", "getProducts", "getProductOptions", "getProjects", "getDepartments", "getUnits", "getCategories", "getSubUnits", "getSubCategories"]),
      payments () { return this.getPayments || [] },
      suppliers () { return this.filterPrequalified(this.getSuppliers || []) },
      products () { return this.getProducts || [] },
      units() { return this.getUnits || [] },
      subUnits() { return this.getSubUnits || [] },
      categories() { return this.getCategories || [] },
      subcategories() { return this.getSubCategories || [] },
      // Filter subunits to those that belong to the selected unit in newProduct
      filteredSubUnits() {
        const unitId = this.newProduct && this.newProduct.unitId ? Number(this.newProduct.unitId) : null
        if (!unitId) return this.subUnits || []
        return (this.subUnits || []).filter(su => {
          if (!su) return false
          if (su.unitId && Number(su.unitId) === unitId) return true
          if (su.unit && typeof su.unit === 'object' && su.unit.id && Number(su.unit.id) === unitId) return true
          if (su.unit && (typeof su.unit === 'string' || typeof su.unit === 'number') && String(su.unit) === String(unitId)) return true
          // some API shapes return the parent unit under `subunit`
          if (su.subunit && typeof su.subunit === 'object' && su.subunit.id && Number(su.subunit.id) === unitId) return true
          if (su.subunit && (typeof su.subunit === 'string' || typeof su.subunit === 'number') && String(su.subunit) === String(unitId)) return true
          return false
        })
      },
      // Filter subcategories to those that belong to the selected category in newProduct
      filteredSubcategories() {
        const categoryId = this.newProduct && this.newProduct.categoryId ? Number(this.newProduct.categoryId) : null
        if (!categoryId) return this.subcategories || []
        return (this.subcategories || []).filter(sc => {
          if (!sc) return false
          if (sc.categoryId && Number(sc.categoryId) === categoryId) return true
          if (sc.category && typeof sc.category === 'object' && sc.category.id && Number(sc.category.id) === categoryId) return true
          if (sc.category && (typeof sc.category === 'string' || typeof sc.category === 'number') && String(sc.category) === String(categoryId)) return true
          // some API shapes return the parent category under `subcategory`
          if (sc.subcategory && typeof sc.subcategory === 'object' && sc.subcategory.id && Number(sc.subcategory.id) === categoryId) return true
          if (sc.subcategory && (typeof sc.subcategory === 'string' || typeof sc.subcategory === 'number') && String(sc.subcategory) === String(categoryId)) return true
          return false
        })
      },
      productOptions () { return this.getProductOptions || [] },
      projects() { return this.getProjects || [] },
      departments () { return this.getDepartments || [] },
      paymentDueDate() {
        if (!this.deliveryDate || !this.creditPeriod) return null
        const d = new Date(this.deliveryDate)
        if (isNaN(d.getTime())) return null
        d.setDate(d.getDate() + Number(this.creditPeriod))
        return d.toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' })
      },
      supplierInputDisabled() {
        return !!(this.tenderId || this.tenderSubmissionId)
      },
      isContractAward() {
        const submission = (this.tenderSubmissions || []).find(s => s.id === this.tenderSubmissionId)
        return !!(submission && submission.tenderContract)
      },
      selectedSupplierName() {
        if (!this.supplierId) return ''
        const s = (this.suppliers || []).find(x => x.id === this.supplierId) || (this.getSuppliers || []).find(x => x.id === this.supplierId)
        return (s && s.name) || this.supplierContact || ''
      },
      productAmount () { 
        const price = Number(this.productPrice) || 0
        const qty = Number(this.productRequest) || 0
        return price * qty
      },
      discountAmount () {
        const d = Number(this.discount) || 0
        if (d <= 0) return 0
        return this.total * (d / 100)
      },
      taxableBase () {
        return Math.max(0, this.total - this.discountAmount)
      },
      vatAmount () {
        if (!this.vat) return 0
        return this.taxableBase * 0.16
      },
      netTotal () {
        return this.taxableBase + this.vatAmount
      },
      currency() {
        // Find the selected submission to get its proposed currency
        const submission = (this.tenderSubmissions || []).find(s => s.id === this.tenderSubmissionId);
        if (submission && submission.proposedCurrency) return submission.proposedCurrency;
        
        // Fallback to the tender's base currency if no submission or submission currency is missing
        if (this.tenderId) {
          const tender = (this.tenders || []).find(t => t.id === this.tenderId);
          if (tender && tender.currency) return tender.currency;
        }
        
        // Default to KES as requested
        return 'KES';
      }
    },
    methods: {
      ...mapActions(["fetchPayments", "fetchSuppliers", "fetchProducts","fetchProjects", "fetchDepartments", "fetchUnits", "fetchCategories", "fetchSubUnits", "fetchSubCategories"]),
      getSubcategoryLabel(sc) {
        if (!sc) return '';
        if (typeof sc === 'string') return sc;
        if (sc.category && typeof sc.category === 'string') return sc.category;
        if (sc.name && typeof sc.name === 'string') return sc.name;
        if (sc.subcategory && sc.subcategory.category) return sc.subcategory.category;
        // Fallback to any nested category string
        if (sc.category && typeof sc.category === 'object' && sc.category.category) return sc.category.category;
        return '';
      },
      async fetchPurchaseVerifiers(departmentId) {
        if (!departmentId) {
          this.purchaseVerifiers = []
          return
        }
        this.verifiersLoading = true
        this.purchaseVerifiers = []
        try {
          const url = `${process.env.VUE_APP_URL}/departments/${departmentId}/purchase-verifiers`
          console.log('[AddPurchase] fetchPurchaseVerifiers departmentId:', departmentId, 'url:', url)
          const res = await fetch(url, { headers: { Accept: 'application/json', Authorization: this.token ? `Bearer ${this.token}` : '' } })
          const data = await res.json()
          console.log('[AddPurchase] fetchPurchaseVerifiers response:', res.status, data)
          if (res.ok) {
            this.purchaseVerifiers = Array.isArray(data) ? data : (data.data || data.verifiers || [])
            console.log('[AddPurchase] purchaseVerifiers:', this.purchaseVerifiers)
          }
        } catch (e) {
          console.error('Failed to fetch purchase verifiers', e)
          this.purchaseVerifiers = []
        } finally {
          this.verifiersLoading = false
        }
      },
      async fetchPurchaseStampers(departmentId) {
        if (!departmentId) {
          this.purchaseStampers = []
          return
        }
        this.stampersLoading = true
        this.purchaseStampers = []
        try {
          const url = `${process.env.VUE_APP_URL}/departments/${departmentId}/purchase-stampers`
          console.log('[AddPurchase] fetchPurchaseStampers departmentId:', departmentId, 'url:', url)
          const res = await fetch(url, { headers: { Accept: 'application/json', Authorization: this.token ? `Bearer ${this.token}` : '' } })
          const data = await res.json()
          console.log('[AddPurchase] fetchPurchaseStampers response:', res.status, data)
          if (res.ok) {
            this.purchaseStampers = Array.isArray(data) ? data : (data.data || data.stampers || [])
            console.log('[AddPurchase] purchaseStampers:', this.purchaseStampers)
          }
        } catch (e) {
          console.error('Failed to fetch purchase stampers', e)
          this.purchaseStampers = []
        } finally {
          this.stampersLoading = false
        }
      },
      async fetchPurchaseCeoStampers(departmentId) {
        if (!departmentId) {
          this.purchaseCeoStampers = []
          return
        }
        this.ceoStampersLoading = true
        this.purchaseCeoStampers = []
        try {
          const url = `${process.env.VUE_APP_URL}/departments/${departmentId}/purchase-ceo-stampers`
          console.log('[AddPurchase] fetchPurchaseCeoStampers departmentId:', departmentId, 'url:', url)
          const res = await fetch(url, { headers: { Accept: 'application/json', Authorization: this.token ? `Bearer ${this.token}` : '' } })
          const data = await res.json()
          console.log('[AddPurchase] fetchPurchaseCeoStampers response:', res.status, data)
          if (res.ok) {
            this.purchaseCeoStampers = Array.isArray(data) ? data : (data.data || data.ceoStampers || [])
            console.log('[AddPurchase] purchaseCeoStampers:', this.purchaseCeoStampers)
          }
        } catch (e) {
          console.error('Failed to fetch purchase CEO stampers', e)
          this.purchaseCeoStampers = []
        } finally {
          this.ceoStampersLoading = false
        }
      },
      onTenderChange() {
        // ensure items and tender-related state are cleared when user selects the None option
        if (!this.tenderId) {
          this.supplierId = ''
          this.supplierContact = ''
          this.tenderSubmissions = []
          this.tenderSubmissionId = null
          this.tenderSubmissionDisabled = false
          this.items = []
        }
      },
      async fetchTenders() {
          this.tendersLoading = true
          try {
            const preselectedTenderId = this.$route?.query?.tenderId ? Number(this.$route.query.tenderId) || this.$route.query.tenderId : null
            const res = await fetch((process.env.VUE_APP_URL) + '/tender?status=PUBLISHED&limit=1000', {
              headers: { 'Accept': 'application/json', 'Authorization': this.token ? `Bearer ${this.token}` : '' }
            })
            if (!res.ok) return this.tenders = []
            const data = await res.json()
            let allTenders = data.data || []
            // Filter tenders to only those that have at least one AWARDED submission (include normal awards without contract)
            try {
              const subsRes = await tenderApi.getAllSubmissions({ status: 'AWARDED', limit: 1000, includeAllAwarded: true })
              const subsPayload = subsRes && subsRes.data ? subsRes.data : subsRes
              const awardedSubs = Array.isArray(subsPayload) ? subsPayload : (Array.isArray(subsPayload.data) ? subsPayload.data : [])
              const awardedTenderIds = new Set(awardedSubs.map(s => Number(s.tenderId || (s.tender && s.tender.id))).filter(val => !isNaN(val)))
              allTenders = allTenders.filter(t => awardedTenderIds.has(Number(t.id)))

              // Further filter to only tenders that have quantities that have not yet been ordered
              const tendersWithQuantity = []
              await Promise.all(allTenders.map(async (t) => {
                try {
                  const itemsRes = await tenderApi.getTenderItemsWithAvailability(t.id)
                  const payload = (itemsRes && itemsRes.data) ? itemsRes.data : itemsRes
                  const itemsArray = Array.isArray(payload) ? payload : (Array.isArray(payload?.items) ? payload.items : [])
                  
                  // if no items are defined, we have no quantity constraint, so allow it. 
                  // If items exist, at least one must have availableQuantity > 0.
                  if (itemsArray.length === 0 || itemsArray.some(item => Number(item.availableQuantity) > 0)) {
                    tendersWithQuantity.push(t)
                  }
                } catch (e) {
                  console.error('Error checking availability for tender', t.id, e)
                  // On error, we still include it so we don't accidentally hide valid tenders
                  tendersWithQuantity.push(t)
                }
              }))

              this.tenders = tendersWithQuantity

              // If we have a preselected tender from query (e.g. Award to Lowest Bids) that was filtered out, add it
              if (preselectedTenderId && !this.tenders.some(t => t.id === preselectedTenderId)) {
                try {
                  const tRes = await tenderApi.getTender(preselectedTenderId)
                  const t = (tRes && tRes.data) ? tRes.data : tRes
                  if (t && t.id) {
                    this.tenders = [...this.tenders, t]
                  }
                } catch (e) {
                  console.warn('Could not fetch preselected tender for dropdown', e)
                }
              }
            } catch (err) {
              console.error('Error fetching awarded submissions for tender filter', err)
              this.tenders = allTenders
            }
          } catch (err) {
            console.error('Error fetching tenders', err)
            this.tenders = []
          } finally {
            this.tendersLoading = false
          }
        },

          async fetchAwardedSubmissions(tenderId, includeAllForLowestBid = false) {
            if (!tenderId) {
              this.tenderSubmissions = []
              return
            }
            try {
              const params = includeAllForLowestBid ? {} : { status: 'AWARDED' }
              const res = await tenderApi.getTenderSubmissions(tenderId, params)
              const payload = res && res.data ? res.data : res
              if (Array.isArray(payload)) this.tenderSubmissions = payload
              else if (Array.isArray(payload.data)) this.tenderSubmissions = payload.data
              else this.tenderSubmissions = []
              // auto-select and disable when exactly one awarded submission exists (and not in lowest bid mode)
              if (!includeAllForLowestBid && this.tenderSubmissions.length === 1) {
                this.tenderSubmissionId = this.tenderSubmissions[0].id
                this.tenderSubmissionDisabled = true
              } else {
                this.tenderSubmissionDisabled = includeAllForLowestBid
              }
            } catch (err) {
              console.error('Error fetching awarded submissions', err)
              this.tenderSubmissions = []
              this.tenderSubmissionDisabled = false
            }
          },

        async fetchTenderDetails(id) {
          if (!id) return
          try {
            const res = await fetch((process.env.VUE_APP_URL) + `/tender/${id}`, {
              headers: { 'Accept': 'application/json', 'Authorization': this.token ? `Bearer ${this.token}` : '' }
            })
            if (!res.ok) return
            const data = await res.json()
            const tender = data.data || data.tender || data
            // find awarded submission
            const awarded = (tender.submissions || []).find(s => s.status === 'AWARDED')
            if (awarded) {
              // prefer explicit supplier id from submission
              const supplierIdFromSubmission = awarded.supplierId || (awarded.Supplier && awarded.Supplier.id) || awarded.supplier || null
              if (supplierIdFromSubmission) {
                this.supplierId = supplierIdFromSubmission
                // try to find supplier object for contact info
                const matchedById = (this.suppliers || []).find(s => s.id === supplierIdFromSubmission) || (this.getSuppliers || []).find(s => s.id === supplierIdFromSubmission)
                if (matchedById) this.supplierContact = matchedById.address || matchedById.contact || matchedById.phone || matchedById.email || ''
              } else if (awarded.companyEmail) {
                // try to find supplier by email
                const matched = (this.suppliers || []).find(s => s.email && s.email.toLowerCase() === awarded.companyEmail.toLowerCase()) || (this.getSuppliers || []).find(s => s.email && s.email.toLowerCase() === awarded.companyEmail.toLowerCase())
                if (matched) {
                  this.supplierId = matched.id
                  this.supplierContact = matched.address || matched.contact || matched.phone || matched.email || ''
                } else {
                  // no matching supplier record; prefill contact email field
                  this.supplierContact = awarded.companyEmail || awarded.companyName || ''
                }
              } else if (awarded.companyName) {
                // try to match by company name (case-insensitive substring)
                const matched = (this.suppliers || []).find(s => s.name && s.name.toLowerCase().includes(awarded.companyName.toLowerCase())) || (this.getSuppliers || []).find(s => s.name && s.name.toLowerCase().includes(awarded.companyName.toLowerCase()))
                if (matched) {
                  this.supplierId = matched.id
                  this.supplierContact = matched.address || matched.contact || matched.phone || matched.email || ''
                } else {
                  this.supplierContact = awarded.companyName || ''
                }
              }
            }
            // Prefill requisition number from linked purchase request if available
            try {
              if (tender.purchaseRequestId) {
                const prRes = await fetch((process.env.VUE_APP_URL || process.env.VUE_APP_URL) + `/purchase-requests/${tender.purchaseRequestId}`, {
                  headers: { 'Accept': 'application/json', 'Authorization': this.token ? `Bearer ${this.token}` : '' }
                })
                if (prRes && prRes.ok) {
                  const prData = await prRes.json()
                  const pr = prData.data || prData || {}
                  this.requisitionNumber = pr.purchaseRequestNo || pr.requestNumber || (pr.id ? `PR${String(pr.id).padStart(6, '0')}` : '')
                  // Prefill project from purchase request. Accept several shapes: string, nested Project, or projectId.
                  try {
                    let prProjectName = null
                    if (pr.project && typeof pr.project === 'string') prProjectName = pr.project
                    else if (pr.projectName) prProjectName = pr.projectName
                    else if (pr.Project && (pr.Project.name || pr.Project.title)) prProjectName = pr.Project.name || pr.Project.title
                    else if (pr.projectId) {
                      const proj = (this.getProjects || []).find(p => p.id === pr.projectId) || (this.projects || []).find(p => p.id === pr.projectId)
                      if (proj) prProjectName = proj.name
                    }
                    if (prProjectName) this.project = prProjectName
                  } catch (e) {
                    // ignore mapping errors
                  }

                  // Prefill department from purchase request. Accept string, nested Department, or departmentId.
                          // Prefill department: map various shapes to department id
                          let prDeptId = null
                          if (pr.departmentId) {
                            prDeptId = pr.departmentId
                          } else if (pr.Department && pr.Department.id) {
                            prDeptId = pr.Department.id
                          } else if (pr.department && typeof pr.department === 'string') {
                            // try to find a department by name
                            const dept = (this.getDepartments || []).find(d => d.name && d.name.toLowerCase() === pr.department.toLowerCase()) || (this.departments || []).find(d => d.name && d.name.toLowerCase() === pr.department.toLowerCase())
                            if (dept) prDeptId = dept.id
                          } else if (pr.departmentName) {
                            const dept = (this.getDepartments || []).find(d => d.name && d.name.toLowerCase() === pr.departmentName.toLowerCase()) || (this.departments || []).find(d => d.name && d.name.toLowerCase() === pr.departmentName.toLowerCase())
                            if (dept) prDeptId = dept.id
                          }
                          if (prDeptId) this.department = prDeptId
                } else {
                  this.requisitionNumber = ''
                }
              } else {
                this.requisitionNumber = ''
              }
            } catch (e) {
              console.error('Failed to prefill requisition number from purchase request', e)
              this.requisitionNumber = ''
            }
          } catch (err) {
            console.error('Error fetching tender details', err)
          }
        },

        async loadTenderItemsForPreview(tenderId) {
          this.itemsLoading = true;
          try {
            let res
            try {
              res = await tenderApi.getTenderItemsWithAvailability(tenderId)
            } catch (e) {
              // fallback if availability endpoint is not present yet (server not restarted)
              console.warn('Availability endpoint failed, falling back to basic items endpoint', e)
              res = await tenderApi.getTenderItems(tenderId)
            }

            const payload = res && res.data ? res.data : res
            const items = payload.items || payload || []
            console.log('Tender items for preview:', items)
            // For contract awards: show all tender items (no availability filter).
            // For normal awards: exclude items with availableQuantity === 0 (strict).
            const submission = (this.tenderSubmissions || []).find(s => s.id === this.tenderSubmissionId)
            const isContract = !!(submission && submission.tenderContract)
            const filtered = isContract
              ? (items || [])
              : (items || []).filter(it => {
                  const aq = it.availableQuantity
                  if (aq === null || aq === undefined) return true
                  return Number(aq) > 0
                })

            console.log('Filtered tender items for preview:', filtered)

            const mapped = filtered.map((it, idx) => {
              const prod = it.product || {}
              const svc = it.service || {}
              const itemName = prod.name || svc.name || it.description || it.productDescription || ''
              const tenderedQty = it.quantity || it.quantityProcessed || it.processedQuantity || 0
              // default requested quantity to availableQuantity when present,
              // otherwise fall back to any explicit requested quantity or the tendered quantity
              const requestedQty = (it.availableQuantity !== undefined && it.availableQuantity !== null)
                ? it.availableQuantity
                : (it.requestedQuantity || it.requestQuantity || it.quantityRequested || tenderedQty)
              return {
                id: `t-${tenderId}-${idx}`,
                tenderItemId: it.id || null,
                Product: {
                  id: prod.id || it.productId || null,
                  name: itemName,
                  code: prod.code || prod.productCode || svc.code || '',
                  unit: { unit: (prod.unit && prod.unit.unit) || (svc.unit && svc.unit.name) || '' },
                },
                service: svc.id ? { id: svc.id, name: svc.name } : null,
                serviceId: svc.id || it.serviceId || null,
                description: itemName,
                tenderedQuantity: tenderedQty,
                availableQuantity: (it.availableQuantity !== undefined ? it.availableQuantity : null),
                quantity: requestedQty,
                price: it.unitPrice || it.estimatedUnitPrice || it.price || 0,
              }
            })

            console.log('Mapped tender items for preview:', mapped)
            this.items = mapped
            // Only apply lowest-bid filter when in that mode (e.g. from "Award to Lowest Bids")
            if (this.lowestBidAwardsMode) {
              this.applyLowestBidFilter()
            }
          } catch (err) {
            console.error('Failed to load tender items for preview', err)
            this.items = []
          } finally {
            this.itemsLoading = false;
          }
        },

        applyLowestBidFilter() {
          try {
            const ctxRaw = sessionStorage.getItem('lowestBidAwardContext')
            const ctx = ctxRaw ? JSON.parse(ctxRaw) : null
            if (!ctx || !ctx.awards || ctx.awards.length === 0) return
            const first = ctx.awards[0]
            const awardItems = first.items || []
            if (awardItems.length === 0) return
            const awardByName = {}
            awardItems.forEach(it => {
              const n = (it.name || '').trim().toLowerCase()
              if (n) awardByName[n] = it
            })
            const normalize = (s) => (s || '').trim().toLowerCase()
            const filtered = (this.items || []).filter(it => {
              const desc = normalize(it.description || (it.Product && it.Product.name) || '')
              const prodName = normalize(it.Product && it.Product.name) || ''
              return Object.keys(awardByName).some(k => desc.includes(k) || k.includes(desc) || prodName.includes(k) || k.includes(prodName))
            })
            if (filtered.length === 0) {
              this.items = (this.items || []).map(it => {
                const desc = (it.description || (it.Product && it.Product.name) || '').trim()
                const match = awardItems.find(a => {
                  const an = (a.name || '').trim()
                  return an && (desc.toLowerCase().includes(an.toLowerCase()) || an.toLowerCase().includes(desc.toLowerCase()))
                })
                if (match) {
                  return { ...it, price: Number(match.unitPrice) || it.price, quantity: Number(match.quantity) || it.quantity || 1 }
                }
                return it
              })
              return
            }
            this.items = filtered.map(it => {
              const desc = (it.description || (it.Product && it.Product.name) || '').trim().toLowerCase()
              const match = awardItems.find(a => {
                const an = (a.name || '').trim().toLowerCase()
                return an && (desc.includes(an) || an.includes(desc))
              })
              if (match) {
                return { ...it, price: Number(match.unitPrice) || it.price, quantity: Number(match.quantity) || it.quantity || 1 }
              }
              return it
            })
          } catch (e) {
            console.warn('Could not apply lowest bid filter', e)
          }
        },
        
        async generatePurchase () {
          this.generatingPurchase = true
          if (this.tenderId) {
            await this.postPurchase()
          }
          if (!this.purchaseId) return Swal.fire({ icon: 'error', title: 'No purchase', text: 'Please create a purchase first' })
          // cannot generate if any item has quantity request set to 0
          const zeroQty = (this.items || []).filter(i => Number(i.quantity) <= 0)
          if (zeroQty.length > 0) {
            const names = zeroQty.map(i => (i.Product && (i.Product.code || i.Product.name)) || i.description).join(', ')
            return Swal.fire({ icon: 'error', title: 'Invalid quantities', text: `Quantity must be greater than 0 for: ${names}` })
          }
          // validate item quantities against availableQuantity before generating (skip for contract awards)
          if (!this.isContractAward) {
            const invalid = (this.items || []).filter(i => (i.availableQuantity !== null && i.availableQuantity !== undefined) && Number(i.quantity) > Number(i.availableQuantity))
            if (invalid.length > 0) {
              const names = invalid.map(i => (i.Product && (i.Product.code || i.Product.name)) || i.description).join(', ')
              return Swal.fire({ icon: 'error', title: 'Invalid quantities', text: `Requested quantity exceeds available for: ${names}` })
            }
          }
          
          try {
            const products = this.items.map(it => ({
              productId: it.Product?.id ?? it.productId ?? null,
              serviceId: it.service?.id ?? it.serviceId ?? null,
              quantity: it.quantity,
              price: it.price,
              description: it.description || (it.Product && it.Product.name) || '',
            }))
            const requestOptions = {
              method: "POST",
              headers: { "Content-Type": "application/json", 'Authorization': 'Bearer '+this.token },
              body: JSON.stringify({ products })
            };
            const res = await fetch((process.env.VUE_APP_URL || process.env.VUE_APP_URL) + '/purchases/generate/' + this.purchaseId, requestOptions)
            // parse safely
            let data = null
            const ct = res.headers.get('content-type') || ''
            if (ct.includes('application/json')) {
              try { data = await res.json() } catch (e) { data = null }
            }
            if (res.ok && data && data.status == true) {
              if (this.lowestBidAwardsMode) {
                try { sessionStorage.removeItem('lowestBidAwardContext') } catch (e) { /* ignore */ }
                this.lowestBidAwardsMode = false
              }
              Swal.fire({
                position: 'top-center',
                icon: 'success',
                title: 'Purchase Generated',
                showConfirmButton: false,
                timer: 1500
              })
              this.$router.push('/purchases')
            } else {
              const msg = (data && data.message) || 'Purchase not generated'
              Swal.fire({ icon: 'error', title: 'Purchase not generated', text: msg })
            }
          } catch (err) {
            console.error('Error generating purchase', err)
            Swal.fire({ icon: 'error', title: 'Error', text: 'Failed to generate purchase' })
          } finally {
            this.generatingPurchase = false
          }
        },

        filterPrequalified(arr) {
          return arr.filter(item => {
            const v = item?.prequalified
            return v === true || v === 'true' || v === 1 || v === '1' || String(v).toLowerCase() === 'yes'
          });
        },

        async postPurchase () {
            this.creatingPurchase = true
            if (!this.tenderId) {
                Swal.fire({
                    icon: 'error',
                    title: 'Purchase Order not created',
                    text: 'Must attach an awarded tender'
                })
            }
            //this.generatingPurchase = true
            try {
              const body = {
                departmentId: this.department ? Number(this.department) : undefined,
                project: this.project,
                supplierId: this.supplierId,
                tenderId: this.tenderId,
                tenderSubmissionId: this.tenderSubmissionId || undefined,
                discount: this.discount,
                vat: this.vat,
                termsAndConditions: this.termsAndConditions
              }
              if (this.deliveryDate) {
                try {
                  body.deliveryDate = new Date(this.deliveryDate).toISOString();
                } catch (e) {
                  body.deliveryDate = this.deliveryDate;
                }
              }
              if (this.creditPeriod !== '' && this.creditPeriod !== null && this.creditPeriod !== undefined) {
                body.creditPeriod = Number(this.creditPeriod);
              }
              // include paymentId only when set to a valid value
              if (this.paymentId !== undefined && this.paymentId !== null && this.paymentId !== '') {
                body.paymentId = Number(this.paymentId)
              }
              const requestOptions = {
                  method: "POST",
                  headers: { "Content-Type": "application/json", 'Authorization': 'Bearer '+this.token },
                  body: JSON.stringify(body)
              };
              const res = await fetch(process.env.VUE_APP_URL+'/purchases', requestOptions)
              const data = await res.json()
              if(data.status == true){
                  this.purchaseId = data.purchase.id
                  this.displayButton = "none"
                  this.displayItems = "block"
                  // If a tender was selected, copy tender items into the created purchase
                 /* if (this.tenderId) {
                    try {
                      await this.addTenderItemsToPurchase(this.tenderId, this.purchaseId)
                    } catch (err) {
                      console.error('Failed to add tender items to purchase', err)
                    }
                  }*/
                  // fetch processed items for this purchase
              }else{
                  Swal.fire({
                      icon: 'error',
                      title: 'Product not created',
                      text: data.message
                  })
              }
            } catch (err) {
              console.error('Error creating purchase', err)
              Swal.fire({ icon: 'error', title: 'Failed', text: 'Failed to create purchase' })
            } finally {
              this.creatingPurchase = false
            }
        },

        async addTenderItemsToPurchase(tenderId, purchaseId) {
          if (!tenderId || !purchaseId) return
          try {
            const res = await tenderApi.getTenderItems(tenderId)
            const payload = res && res.data ? res.data : res
            const items = payload.items || payload || []
            console.log('Fetched tender items payload:', payload)
            console.log('Fetched tender items:', items)
            for (const it of items) {
              const prod = it.product || {}
              const body = {
                description: it.description || prod.name || '',
                quantity: it.quantityProcessed || it.quantity || it.processedQuantity || 0,
                price: it.unitPrice || it.estimatedUnitPrice || it.price || 0,
                purchaseId: purchaseId,
                productId: prod.id || it.productId || undefined,
              }
              try {
                const requestOptions = {
                  method: 'POST',
                  headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + this.token },
                  body: JSON.stringify(body),
                }
                await fetch((process.env.VUE_APP_URL || process.env.VUE_APP_URL) + '/purchases/products', requestOptions)
              } catch (e) {
                console.error('Failed to add purchase product', e)
              }
            }
          } catch (e) {
            console.error('Failed to load tender items', e)
          } finally {
            this.itemsLoading = false;
          }
        },

        async fetchPurchaseItems() {
          if (!this.purchaseId) return
          try {
            const res = await fetch(process.env.VUE_APP_URL + '/purchases/' + this.purchaseId, {
              headers: { 'Accept': 'application/json', 'Authorization': 'Bearer ' + this.token }
            })
            const data = await res.json()
            // API returns full purchase under data.purchase with PurchaseProduct array
            const p = data.purchase || data
            // map basic header fields so the form can be edited
            if (p) {
              this.department = p.departmentId || p.department || this.department
              this.project = p.project || this.project
              this.supplierId = p.supplierId || (p.Supplier && p.Supplier.id) || this.supplierId
              this.vat = p.vat === undefined ? this.vat : p.vat
              this.discount = p.discount === undefined ? this.discount : p.discount
              this.termsAndConditions = p.termsAndConditions || this.termsAndConditions
              this.deliveryDate = p.deliveryDate || this.deliveryDate
              this.creditPeriod = p.creditPeriod !== undefined ? p.creditPeriod : this.creditPeriod
              this.isCredit = !!(p.isCredit)
              this.isPaid = !!(p.isPaid)
              this.canBeFulfilled = !!(p.canBeFulfilled)
            }
            // map products (PurchaseProduct)
            this.items = (p && (p.PurchaseProduct || p.items || p.products)) || []
          } catch (err) {
            console.error('Error fetching purchase items', err)
          }
        },

        async postProduct() {
          const requestOptions = {
                method: "POST",
                headers: { "Content-Type": "application/json", 'Authorization': 'Bearer '+this.token },
                body: JSON.stringify({ 
                  description: this.productDescription,
                  quantity: this.productRequest,
                  price: this.productPrice,
                  purchaseId: this.purchaseId,
                  productId: this.productId,
                })
            };
            const res = await fetch(process.env.VUE_APP_URL+'/purchases/products', requestOptions)
            const data = await res.json()
            if(data.status == true){
              this.productRequest = ""
              this.productDescription = ""
              this.productPrice = ""
              this.items = data.products
            }else{
                Swal.fire({
                    icon: 'error',
                    title: 'Product not added',
                    text: data.message
                })
            }
        },
        async deleteProduct(id) {
          // If the item id is not a numeric DB id (e.g., preview id like 't-<tid>-<idx>')
          // or there is no saved purchase yet, remove locally without calling API.
          const isNumericId = String(id).match(/^\d+$/)
          if (!isNumericId || !this.purchaseId) {
            this.items = (this.items || []).filter(i => i.id !== id)
            return
          }

          const requestOptions = {
            method: "DELETE",
            headers: { "Content-Type": "application/json", 'Authorization': 'Bearer '+this.token }
          };
          const res = await fetch(process.env.VUE_APP_URL+'/purchases/products/'+id+'/'+this.purchaseId, requestOptions)
          const data = await res.json()
          if(data.status == true){
            this.items = data.products
          }else{
            Swal.fire({
              icon: 'error',
              title: 'Purchase Order Product not deleted',
              text: data.message
            })
          }
        },

        async toggleIsPaid() {
          if (!this.purchaseId || this.togglingPayment) return
          this.togglingPayment = true
          try {
            const newValue = !this.isPaid
            const res = await fetch(process.env.VUE_APP_URL + '/purchases/' + this.purchaseId + '/payment-status', {
              method: 'PATCH',
              headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + this.token },
              body: JSON.stringify({ isPaid: newValue })
            })
            const data = await res.json()
            if (data.status) {
              this.isPaid = data.purchase.isPaid
            } else {
              if (this.$toast && typeof this.$toast.error === 'function') this.$toast.error('Failed to update payment status')
            }
          } catch (e) {
            console.error('toggleIsPaid error', e)
            if (this.$toast && typeof this.$toast.error === 'function') this.$toast.error('Failed to update payment status')
          } finally {
            this.togglingPayment = false
          }
        },

        openNewProductModal() {
          this.newProduct = {
            name: '',
            code: '',
            unitId: null,
            subunitId: null,
            categoryId: null,
            subcategoryId: null,
            pricePurchase: 0,
            sellingPrice: 0,
            brand: '',
            barcode: '',
            reorderLevel: 0,
            taxRate: 0,
            description: ''
          }
          this.showNewProductModal = true
        },
        closeNewProductModal() {
          this.showNewProductModal = false
        },
        async createNewProduct() {
          if (!this.newProduct.name) return Swal.fire({ icon: 'error', title: 'Name required', text: 'Please enter a product name' })
          this.creatingProduct = true
          try {
            const form = new FormData()
            form.append('name', this.newProduct.name)
            if (this.newProduct.code) form.append('code', this.newProduct.code)
            if (this.newProduct.unitId) form.append('unitId', String(this.newProduct.unitId))
            if (this.newProduct.subunitId) form.append('subunitId', String(this.newProduct.subunitId))
            if (this.newProduct.categoryId) form.append('categoryId', String(this.newProduct.categoryId))
            if (this.newProduct.subcategoryId) form.append('subcategoryId', String(this.newProduct.subcategoryId))
            if (this.newProduct.pricePurchase !== undefined) form.append('pricePurchase', String(this.newProduct.pricePurchase))
            if (this.newProduct.sellingPrice !== undefined) form.append('sellingPrice', String(this.newProduct.sellingPrice))
            if (this.newProduct.brand) form.append('brand', this.newProduct.brand)
            if (this.newProduct.barcode) form.append('barcode', this.newProduct.barcode)
            if (this.newProduct.reorderLevel !== undefined) form.append('reorderLevel', String(this.newProduct.reorderLevel))
            if (this.newProduct.taxRate !== undefined) form.append('taxRate', String(this.newProduct.taxRate))
            if (this.newProduct.description) form.append('description', this.newProduct.description)

            const res = await axios.post(process.env.VUE_APP_URL + '/products', form, {
              headers: { 'Content-Type': 'multipart/form-data', 'Authorization': 'Bearer ' + this.token }
            })

            const data = res && res.data ? res.data : res
            if (data && (data.status === true || data.id || data.product)) {
              const created = data.product || data.data || data
              await this.fetchProducts()
              this.productId = created.id || created.productId || created.id
              this.closeNewProductModal()

              if (this.purchaseId) {
                this.productDescription = this.newProduct.description || ''
                this.productRequest = 1
                this.productPrice = this.newProduct.pricePurchase || 0
                await this.postProduct()
              } else {
                const unit = (created.unit && created.unit.unit) ? created.unit : { unit: created.unit || '' }
                const item = {
                  id: `local-${Date.now()}`,
                  Product: { id: created.id, name: created.name, code: created.code, unit },
                  description: this.newProduct.description || created.name || '',
                  tenderedQuantity: 0,
                  availableQuantity: null,
                  quantity: 1,
                  price: this.newProduct.pricePurchase || 0
                }
                this.items.push(item)
              }
              // success — no modal shown as requested
            } else {
              const msg = (data && data.message) || 'Failed to create product'
              Swal.fire({ icon: 'error', title: 'Error', text: msg })
            }
          } catch (err) {
            console.error('Failed to create product', err)
            Swal.fire({ icon: 'error', title: 'Error', text: err.response?.data?.message || 'Failed to create product' })
          } finally {
            this.creatingProduct = false
          }
        }
        
    },
    
    async mounted(){
      this.fetchPayments()
      this.fetchSuppliers()
      this.fetchProducts()
      this.fetchProjects()
      this.fetchDepartments()
      this.fetchUnits()
      this.fetchCategories()
      this.fetchSubUnits()
      this.fetchSubCategories()
      this.fetchTenders()
      // allow opening AddPurchase for editing via query param ?purchaseId=<id>
      try {
        const q = this.$route && this.$route.query ? this.$route.query : null
        if (q && q.purchaseId) {
          this.purchaseId = Number(q.purchaseId) || q.purchaseId
          // load purchase header/details and items
          await this.fetchPurchaseItems()
        } else if (this.purchaseId) {
          // legacy behavior: if purchaseId set programmatically, still load items
          this.fetchPurchaseItems()
        }
      } catch (e) {
        // ignore errors during query processing
      }
      // Preselect tender/submission/supplier when provided via query params
      try {
        const q = this.$route && this.$route.query ? this.$route.query : null
        const isLowestBidAwards = q && q.lowestBidAwards === '1'
        if (isLowestBidAwards) this.lowestBidAwardsMode = true
        if (q && q.tenderId) {
          this.tenderId = Number(q.tenderId) || q.tenderId
          // Set submission/supplier from query immediately so tenderId watcher can use them for contract vs normal filter
          if (q.tenderSubmissionId) this.tenderSubmissionId = Number(q.tenderSubmissionId) || q.tenderSubmissionId
          if (q.supplierId) this.supplierId = Number(q.supplierId) || q.supplierId
          // When coming from "Award to Lowest Bids", read context from sessionStorage
          if (isLowestBidAwards) {
            try {
              const ctxRaw = sessionStorage.getItem('lowestBidAwardContext')
              const ctx = ctxRaw ? JSON.parse(ctxRaw) : null
              if (ctx && ctx.awards && ctx.awards.length > 0) {
                this.lowestBidAwardCount = ctx.awards.length
                const first = ctx.awards[0]
                this.tenderSubmissionId = first.submissionId
                if (first.supplierId) this.supplierId = first.supplierId
                // Fetch submission to resolve supplierId if not onboarded yet
                const subRes = await fetch((process.env.VUE_APP_URL || '') + `/tender/submission/${first.submissionId}`, {
                  headers: { 'Accept': 'application/json', 'Authorization': this.token ? `Bearer ${this.token}` : '' }
                })
                if (subRes && subRes.ok) {
                  const subData = await subRes.json()
                  const sub = subData.data || subData
                  const sid = sub?.supplierId || (sub?.supplier && sub.supplier.id) || (sub?.Supplier && sub.Supplier.id)
                  if (sid) this.supplierId = sid
                  if (!this.supplierId && sub?.companyEmail) {
                    const suppliersRes = await fetch((process.env.VUE_APP_URL || '') + '/suppliers', {
                      headers: { 'Accept': 'application/json', 'Authorization': this.token ? `Bearer ${this.token}` : '' }
                    })
                    if (suppliersRes && suppliersRes.ok) {
                      const suppData = await suppliersRes.json()
                      const list = suppData.data || suppData
                      const matched = (Array.isArray(list) ? list : []).find(s => s.email && s.email.toLowerCase() === (sub.companyEmail || '').toLowerCase())
                      if (matched) this.supplierId = matched.id
                    }
                  }
                  this.supplierContact = sub?.companyEmail || sub?.companyName || sub?.contactPerson || ''
                }
              }
            } catch (e) {
              console.warn('Could not load lowest bid award context', e)
            }
          }
          // fetch tender details and awarded submissions then set submission/supplier
          this.fetchTenderDetails(this.tenderId)
          this.fetchAwardedSubmissions(this.tenderId, isLowestBidAwards).then(() => {
            if (q.tenderSubmissionId) this.tenderSubmissionId = Number(q.tenderSubmissionId) || q.tenderSubmissionId
            if (q.supplierId) this.supplierId = Number(q.supplierId) || q.supplierId
          }).catch(() => {
            if (q.tenderSubmissionId) this.tenderSubmissionId = Number(q.tenderSubmissionId) || q.tenderSubmissionId
            if (q.supplierId) this.supplierId = Number(q.supplierId) || q.supplierId
          })
        }
      } catch (e) {
        // ignore query mapping errors
      }
    },
    watch: {
      department(val) {
        this.fetchPurchaseVerifiers(val)
        this.fetchPurchaseStampers(val)
        this.fetchPurchaseCeoStampers(val)
      },
      async tenderId(val){
        if (val) {
          this.fetchTenderDetails(val)
          await this.fetchAwardedSubmissions(val, this.lowestBidAwardsMode)
          // load tender products for preview when creating a new purchase (after submissions loaded so we can check contract vs normal)
          // skip when tenderSubmissionId is set - that watcher will load items and prefill prices (avoids race where we overwrite prefilled prices)
          if (!this.purchaseId && !this.tenderSubmissionId) {
            await this.loadTenderItemsForPreview(val)
          }
        }
        else {
          // clear supplier selection if tender cleared
          this.supplierId = ''
          this.supplierContact = ''
          this.tenderSubmissions = []
          this.tenderSubmissionId = null
          this.tenderSubmissionDisabled = false
          // clear any loaded tender items when user selects "None"
          this.items = []
        }
      },
      async tenderSubmissionId(val){
        if (!val) return
        const submission = (this.tenderSubmissions || []).find(s => s.id === val)
        // Reload tender items with correct availability filter (contract vs normal)
        if (!this.purchaseId && this.tenderId) {
          await this.loadTenderItemsForPreview(this.tenderId)
        }
        // Supplier info only when we have submission from list
        if (submission) {
          const supplierIdFromSubmission = submission.supplierId || (submission.Supplier && submission.Supplier.id) || submission.supplier || null
          if (supplierIdFromSubmission) {
            this.supplierId = supplierIdFromSubmission
            const matchedById = (this.suppliers || []).find(s => s.id === supplierIdFromSubmission) || (this.getSuppliers || []).find(s => s.id === supplierIdFromSubmission)
            if (matchedById) this.supplierContact = matchedById.address || matchedById.contact || matchedById.phone || matchedById.email || ''
          } else if (submission.companyEmail) {
            const matched = (this.suppliers || []).find(s => s.email && s.email.toLowerCase() === submission.companyEmail.toLowerCase()) || (this.getSuppliers || []).find(s => s.email && s.email.toLowerCase() === submission.companyEmail.toLowerCase())
            if (matched) {
              this.supplierId = matched.id
              this.supplierContact = matched.address || matched.contact || matched.phone || matched.email || ''
            } else {
              this.supplierContact = submission.companyEmail || submission.companyName || ''
            }
          }
        }
        // Always prefill prices from quotation (contract and normal)
        try {
          const token = this.token
          const res = await fetch((process.env.VUE_APP_URL || '') + `/tender/submission/${val}`, {
            headers: { 'Accept': 'application/json', 'Authorization': token ? `Bearer ${token}` : '' }
          })
          if (res && res.ok) {
            const data = await res.json()
            const payload = data.data || data
            const qRaw = payload && (payload.quotation || payload.Quotation)
            let q = null
            if (qRaw) {
              try { q = typeof qRaw === 'string' ? JSON.parse(qRaw) : qRaw } catch (e) { q = qRaw }
            }
            if (q && Array.isArray(q.items) && (this.items || [])?.length > 0) {
              // map by product id, tender item id, code, or name (quotation id can be either)
              const priceMap = {}
              q.items.forEach(it => {
                const keyId = it.id ? String(it.id) : null
                const name = (it.name || it.description || '').trim().toLowerCase()
                const code = (it.code || '').toLowerCase()
                const unitPrice = Number(it.unitPrice != null ? it.unitPrice : (it.price != null ? it.price : it.total || 0)) || 0
                if (keyId) priceMap[`id:${keyId}`] = unitPrice
                if (code) priceMap[`code:${code}`] = unitPrice
                if (name) priceMap[`name:${name}`] = unitPrice
              })
              // Apply prices to this.items by matching product id, tender item id, code, or name
              this.items = (this.items || []).map(it => {
                try {
                  const prodId = it.Product && it.Product.id ? String(it.Product.id) : null
                  const tenderItemId = it.tenderItemId ? String(it.tenderItemId) : null
                  const code = ((it.Product && (it.Product.code || it.Product.productCode)) || it.code || '').toLowerCase()
                  const name = (it.description || (it.Product && (it.Product.name || it.Product.description)) || '').trim().toLowerCase()
                  let matchedPrice = null
                  if (prodId && priceMap[`id:${prodId}`] != null) matchedPrice = priceMap[`id:${prodId}`]
                  else if (tenderItemId && priceMap[`id:${tenderItemId}`] != null) matchedPrice = priceMap[`id:${tenderItemId}`]
                  else if (code && priceMap[`code:${code}`] != null) matchedPrice = priceMap[`code:${code}`]
                  else if (name && priceMap[`name:${name}`] != null) matchedPrice = priceMap[`name:${name}`]
                  else if (name) {
                    // fallback: partial name match (quotation name may differ slightly)
                    const qNameKeys = Object.keys(priceMap).filter(k => k.startsWith('name:'))
                    const partial = qNameKeys.find(k => {
                      const qn = k.slice(5)
                      return name.includes(qn) || qn.includes(name)
                    })
                    if (partial) matchedPrice = priceMap[partial]
                  }
                  if (matchedPrice != null) {
                    return { ...it, price: matchedPrice }
                  }
                } catch (e) {
                  // ignore mapping errors per item
                }
                return it
              })
            }
          }
        } catch (e) {
          console.warn('Failed to prefill prices from submission quotation', e)
        }
      },
      supplierId(newValue){
        const supplierObj = this.suppliers.find(i => i.id === newValue) || {}
        this.supplierContact = supplierObj.address || supplierObj.contact || supplierObj.phone || supplierObj.email || ''
      },
      productId(newValue){
        const item = this.products.find(i => i.id === newValue) || {}
        this.productCode = item.code || ''
        this.productUnit = (item.unit && item.unit.unit) || ''
      },
      'newProduct.unitId'() {
        // if selected subunit no longer matches the chosen unit, clear it
        const cur = this.newProduct && this.newProduct.subunitId
        if (!cur) return
        const match = (this.filteredSubUnits || []).find(su => Number(su.id) === Number(cur))
        if (!match) this.newProduct.subunitId = null
      },
      'newProduct.categoryId'() {
        // if selected subcategory no longer matches the chosen category, clear it
        const cur = this.newProduct && this.newProduct.subcategoryId
        if (!cur) return
        const match = (this.filteredSubcategories || []).find(sc => Number(sc.id) === Number(cur))
        if (!match) this.newProduct.subcategoryId = null
      },
      items: {
        handler(newValue){
          var sum = 0;
          (newValue || []).forEach(e => {
            const price = Number(e.price) || 0
            const qty = Number(e.quantity) || 0
            sum += price * qty
          });
          this.total = sum
        },
        deep: true
      }
    }
  }
  </script>


<style lang="scss">
$text-color: #000000;
input[readonly]{
  background-color: #cfcece !important;
}

select {
  /* inline SVG */
  background: url("data:image/svg+xml;charset=US-ASCII,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20viewBox%3D%220%200%20256%20448%22%20enable-background%3D%22new%200%200%20256%20448%22%3E%3Cstyle%20type%3D%22text%2Fcss%22%3E.arrow%7Bfill%3A%23424242%3B%7D%3C%2Fstyle%3E%3Cpath%20class%3D%22arrow%22%20d%3D%22M255.9%20168c0-4.2-1.6-7.9-4.8-11.2-3.2-3.2-6.9-4.8-11.2-4.8H16c-4.2%200-7.9%201.6-11.2%204.8S0%20163.8%200%20168c0%204.4%201.6%208.2%204.8%2011.4l112%20112c3.1%203.1%206.8%204.6%2011.2%204.6%204.4%200%208.2-1.5%2011.4-4.6l112-112c3-3.2%204.5-7%204.5-11.4z%22%2F%3E%3C%2Fsvg%3E%0A"), #fff;
  background-position: right 10px center;
  background-repeat: no-repeat;
  background-size: auto 50%;
  border-radius: 3px;
  height: 45px;
  border: 1px solid #b4c7e7 !important;
  padding: 5px 30px 5px 10px;
  // disable default appearance
  outline: none;
  -moz-appearance: none;
  -webkit-appearance: none;
  appearance: none;
  &::-ms-expand { display: none };
  &.full{
    width: 100%;
  }
  &:focus, &:hover{
    background: url("data:image/svg+xml;charset=US-ASCII,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20viewBox%3D%220%200%20256%20448%22%20enable-background%3D%22new%200%200%20256%20448%22%3E%3Cstyle%20type%3D%22text%2Fcss%22%3E.arrow%7Bfill%3A%23424242%3B%7D%3C%2Fstyle%3E%3Cpath%20class%3D%22arrow%22%20d%3D%22M255.9%20168c0-4.2-1.6-7.9-4.8-11.2-3.2-3.2-6.9-4.8-11.2-4.8H16c-4.2%200-7.9%201.6-11.2%204.8S0%20163.8%200%20168c0%204.4%201.6%208.2%204.8%2011.4l112%20112c3.1%203.1%206.8%204.6%2011.2%204.6%204.4%200%208.2-1.5%2011.4-4.6l112-112c3-3.2%204.5-7%204.5-11.4z%22%2F%3E%3C%2Fsvg%3E%0A"), #fff;
    border: 1px solid $text-color;
    background-position: right 10px center;
    background-repeat: no-repeat;
    background-size: auto 50%;
  }
}


$primary: #d2d2d2;
$green: #000000;
$white: #ffffff;

.verifier-badge-list {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
  align-items: center;
  min-height: 38px;
}

  .check-button{
        display: flex;
        align-items: center;
        gap: 10px;
      }
      .form-group{
        .components-button {
          display: flex;
          align-items: center;
          justify-content: left;
          span.switcher {
            position: relative;
            width: 156px;
            height: 56px;
            border-radius: 10px;
            input {
              appearance: none;
              position: relative;
              width: 130px;
              height: 40px;
              border-radius: 3px;
              border-color: #d2d2d2 !important;
              background: $primary;
              outline: none;
              font-family: 'Oswald', sans-serif;
              &:before, &:after {
                z-index: 2;
                position: absolute;
                top: 50%;
                transform: translateY(-50%);
                color: $white;
              }
              &:before {
                content: 'Yes';
                left: 13px;
                font-weight: 600;
                font-size: 13px;
                line-height: 33px;
                color: #FFFFFF;
              }
              &:after {
                content: 'No';
                right: 13px;
                font-weight: 600;
                font-size: 17px;
                line-height: 33px;
                color: #FFFFFF;
              }
            }
            label {
              z-index: 1;
              position: absolute;
              width: 55px;
              height: 32px;
              margin: 0;
              top: 4px;
              left: 71px !important;
              border-radius: 3px;
            }
            &.switcher-1, &.switcher-2 {
              input {
                transition: .25s -.1s;
                &:checked {
                  background: $primary;
                  &:before {
                    color: $white;
                    transition: color .5s .2s;
                  }
                  &:after {
                    color: #ffffff;
                    transition: color .5s;
                  }
                  & + label {
                    left: 4px !important;
                    background: $green;
                    transition: left .5s, right .4s .2s;
                    height: 30px !important;
                  }
                }
                &:not(:checked) {
                  background: $primary;
                  transition: background .5s -.1s;
                  &:before {
                    color: #ffffff;
                    transition: color .5s;
                  }
                  &:after {
                    color: $white;
                    transition: color .5s .2s;
                  }
                  & + label {
                    left: 100px;
                    right: 10px;
                    background: $green;
                    transition: left .4s .2s, right .5s, background .35s -.1s;
                    height: 30px !important;
                  }
                }
              }
            }
          }
        }
      }


        </style>
